export enum PurchaseOrderStatus {
    None = 0,
    Pending = 1,
    Success = 2,
    Failure = 3,
    Delayed = 4
}